import React, { Component } from "react";
import { withCookies } from "react-cookie";
import moment from "moment";
import Store from "../../content/Store";
import styles from "../../assets/css/modules/shared/cookie-bar.css";
import Contentify from "../../content/Contentify";
import { infoOverlayCookie } from "../../constants/Constants";
import { connect } from "react-redux";
import { isHolMol } from "../../helpers/brand/HOLMOLHelper";

export const mapStateToProps = (state) => {
  const selectedPolicy = state.policyReducer.selectedPolicy;

  return {
    isInternational: selectedPolicy && selectedPolicy.IsInternational,
    isSaga: selectedPolicy && selectedPolicy.IsSaga,
    membershipNumber: selectedPolicy && selectedPolicy.MembershipNumber,
    layout: state.layoutReducer && state.layoutReducer.layout
  };
};

export class CookieBar extends Component {
  static content = Store.CookieBar;

  constructor(props) {
    super(props);
    this.onClose = this.onClose.bind(this);
  }

  onClose() {
    const expiryTime = moment(Date.now())
      .add(infoOverlayCookie.expiryYear, "years")
      .toDate();

    this.props.cookies &&
      this.props.cookies.set(infoOverlayCookie.name, infoOverlayCookie.value, {
        expires: expiryTime
      });
  }

  render() {
    const cookieValue =
      this.props.cookies && this.props.cookies.get(infoOverlayCookie.name);

    const canShowCookieBar =
      cookieValue !== infoOverlayCookie.value && !this.props.isInternational;

    let informationLink = (
      <div className="cookie-bar-description">
        {this.props.content.informationLink}
      </div>
    );

    if (
      this.props.isSaga ||
      isHolMol(this.props.membershipNumber, this.props.layout)
    ) {
      informationLink = null;
    }

    return canShowCookieBar ? (
      <div className={`${styles.topAnchor} ${styles.cookieBar}`}>
        <div className="container">
          <div className="row">
            <div className="main-content col-lg-12 col-sm-12">
              <h1 className="cookie-bar-heading">
                {this.props.content.heading}
              </h1>
              <div className="cookie-bar-description">
                {this.props.content.description}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="main-content col-lg-10 col-sm-8">
              {informationLink}
            </div>
            <div className={`col-lg-2 col-sm-4 ${styles.closeButton}`}>
              <button
                onClick={this.onClose}
                className="cookie-bar-button btn btn-ghost btn-ghost-white"
              >
                {this.props.content.buttonText}
              </button>
            </div>
          </div>
        </div>
      </div>
    ) : null;
  }
}

export default withCookies(connect(mapStateToProps)(Contentify(CookieBar)));
